import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useEffect } from "react";

const AssetManagementUseCase = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="min-h-screen bg-white">
        <div className="relative bg-[#0077bb] py-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="relative">
              <h1 className="text-4xl font-bold text-white mb-6">
                Streamline Your Asset Management
              </h1>
              <p className="text-xl text-blue-100 max-w-3xl">
                Track, maintain, and optimize your assets with our comprehensive asset management platform.
              </p>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <section className="py-20">
            <h2 className="text-3xl font-bold text-center mb-12">Key Features</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="p-6 bg-white rounded-lg shadow-lg">
                <h3 className="text-xl font-semibold mb-4">Asset Tracking</h3>
                <p className="text-gray-600">
                  Real-time tracking and monitoring of all your assets in one place.
                </p>
              </div>
              <div className="p-6 bg-white rounded-lg shadow-lg">
                <h3 className="text-xl font-semibold mb-4">Maintenance Scheduling</h3>
                <p className="text-gray-600">
                  Automated maintenance scheduling and preventive maintenance alerts.
                </p>
              </div>
              <div className="p-6 bg-white rounded-lg shadow-lg">
                <h3 className="text-xl font-semibold mb-4">Lifecycle Management</h3>
                <p className="text-gray-600">
                  Track and manage the complete lifecycle of your assets from acquisition to disposal.
                </p>
              </div>
            </div>
          </section>
        </div>

        <div className="w-full bg-gray-50">
          <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center mb-12">Common Use Cases</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white p-6 rounded-lg shadow">
                <h3 className="text-xl font-semibold mb-4">Equipment Management</h3>
                <p className="text-gray-600">
                  Track equipment location, maintenance history, and performance metrics.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow">
                <h3 className="text-xl font-semibold mb-4">IT Asset Management</h3>
                <p className="text-gray-600">
                  Manage hardware, software, and licenses across your organization.
                </p>
              </div>
            </div>
          </section>
        </div>

        <div className="bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <section className="py-20">
              <div className="text-center">
                <h2 className="text-3xl font-bold mb-6">
                  Ready to Transform Your Asset Management?
                </h2>
                <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
                  Join organizations that have revolutionized their operations with our asset management solution.
                </p>
                <div className="space-x-4">
                  <Link to="/request-demo">
                    <Button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
                      Request Demo
                    </Button>
                  </Link>
                  <Link to="/contact">
                    <Button variant="outline" className="border border-blue-600 text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors">
                      Contact Sales
                    </Button>
                  </Link>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssetManagementUseCase;
